<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.66699 7.50008V5.83341C1.66699 3.33341 3.33366 1.66675 5.83366 1.66675H14.167C16.667 1.66675 18.3337 3.33341 18.3337 5.83341V7.50008" stroke="url(#paint0_linear_8764_18519)" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M1.66699 12.5V14.1667C1.66699 16.6667 3.33366 18.3333 5.83366 18.3333H14.167C16.667 18.3333 18.3337 16.6667 18.3337 14.1667V12.5" stroke="url(#paint1_linear_8764_18519)" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M1.66699 10H18.3337" stroke="url(#paint2_linear_8764_18519)" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <defs>
      <linearGradient id="paint0_linear_8764_18519" x1="-0.985834" y1="-3.23487" x2="21.3897" y2="8.34602" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient id="paint1_linear_8764_18519" x1="-0.985834" y1="7.59838" x2="21.3897" y2="19.1793" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient id="paint2_linear_8764_18519" x1="-0.985834" y1="9.15972" x2="1.81879" y2="17.6273" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
    </defs>
  </svg>
</template>
